import { Divider, Grid } from "@mui/material";
import { Stack } from "@mui/system";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { calcProPercentsBasedOnFilterAndDays, itemPercentage, percentageLabel } from "../../../../utilis/common";
import { calculateDiffBetweenPercentages, pickComparisonColor } from "../../../../utilis/percentage-comparison";
import ColorBox from "../../../../components/shared/dashboard/ColorBox";
import styles from "./TotalOverallCard.module.scss";

const TotalOverallOutGoingCard = ({
	total,
	totalComparison,
	isProjection = false,
	totalProjection = 0,
	totalProjectionPercentage,
	outGoingDetailsTotal,
	outGoingDetailsTotalComparison,
	subTitleText = "Avg. Cencus",
	isCompareColor,
	page,
	averageCensus,
	averageCensusComparison,
	filter,
	filterComparison,
	loading,
	projectionDays,
	filterTotal,
	isLayoutMode = false,
}) => {
	const percentage = itemPercentage(total, averageCensus, "number", page, false);
	const percentageComparison = itemPercentage(totalComparison, averageCensusComparison, "number", page, true);
	const { percentageDiff, itemTotalComparisonScaled, numberOfDays } = calculateDiffBetweenPercentages(
		percentage,
		percentageComparison,
		false,
		filter,
		filterComparison,
		totalComparison,
		projectionDays
	);

	const comparisonDiffColor = pickComparisonColor(percentageDiff, false);

	return (
		<div className={`df aic p-t-20 p-b-25 ${styles.totalOverall} ${styles.withSubTotalCardMain}`}>
			<Grid container direction={"row"}>
				<Grid item xs={6}>
					<Stack direction={"column"} justifyContent={"center"} alignItems={"center"}>
						<Stack item direction={"column"}>
							<div
								className={classNames(
									"ffmar-bold",
									"df",
									"aic",
									"fw700",
									"fs49",
									styles.gradientTextPrimary,
									styles.withSubTotalCard,
									loading && styles.skeleton
								)}
							>
								{loading ? (
									<span className="skeleton-text">0</span>
								) : (
									calcProPercentsBasedOnFilterAndDays(total, filter, projectionDays)
								)}
								{isCompareColor && !loading && (
									<ColorBox
										color={comparisonDiffColor}
										comparingAgainst={totalComparison}
										comparingAgainstScaled={itemTotalComparisonScaled}
										numberOfDays={numberOfDays}
										isTotalOverallCard={true}
									/>
								)}
							</div>
							{percentage && (
								<div className={classNames(styles.textNumberContainer, styles.textNumberSubContainer)}>
									<div
										className={classNames(
											styles.gradientTextSecondary,
											loading && styles.skeleton,
											loading && "skeleton-text"
										)}
									>{`(${
										loading
											? 0
											: calcProPercentsBasedOnFilterAndDays(
													percentage,
													filter,
													projectionDays,
													filterTotal,
													averageCensus
											  )
									})%`}</div>
									<div className={classNames(styles.gradientTextSubtitle, loading && "skeleton-text")}>
										{loading ? (
											<span className="skeleton-text" style={{ visibility: "hidden" }}>
												{subTitleText}
											</span>
										) : (
											subTitleText
										)}
									</div>
								</div>
							)}
						</Stack>
					</Stack>
				</Grid>
				<Divider orientation="vertical" flexItem />
				<Grid item xs={5}>
					<Stack
						direction={"column"}
						spacing={1}
						justifyContent={"center"}
						alignContent={"center"}
						alignItems={"center"}
						sx={{ height: "100%" }}
					>
						<SubTotalCardItem
							title={"Hospital Transfer"}
							loading={loading}
							total={calcProPercentsBasedOnFilterAndDays(
								outGoingDetailsTotal?.totalHospitalTransfer || 0,
								filter,
								projectionDays
							)}
							totalComparisonRaw={outGoingDetailsTotalComparison?.totalHospitalTransfer || 0}
							totalRaw={outGoingDetailsTotal?.totalHospitalTransfer || 0}
							totalOutgoingRaw={total}
							totalOutgoingComparisonRaw={totalComparison}
							percentage={percentageLabel(
								calcProPercentsBasedOnFilterAndDays(
									itemPercentage(outGoingDetailsTotal?.totalHospitalTransfer || 0, total, "number"),
									filter,
									projectionDays,
									filterTotal,
									averageCensus
								)
							)}
							percentageValue={itemPercentage(outGoingDetailsTotal?.totalHospitalTransfer || 0, averageCensus, "number")}
							percentageComparison={itemPercentage(outGoingDetailsTotalComparison?.totalHospitalTransfer || 0, averageCensus, "number")}
							filter={filter}
							filterComparison={filterComparison}
							projectionDays={projectionDays}
							isCompareColor={isCompareColor}
							isLayoutMode={isLayoutMode}
						/>
						<SubTotalCardItem
							title={"Community Transfer"}
							loading={loading}
							total={calcProPercentsBasedOnFilterAndDays(
								outGoingDetailsTotal?.totalCommunityTransfer || 0,
								filter,
								projectionDays
							)}
							totalComparisonRaw={outGoingDetailsTotalComparison?.totalCommunityTransfer || 0}
							totalRaw={outGoingDetailsTotal?.totalCommunityTransfer || 0}
							totalOutgoingRaw={total}
							totalOutgoingComparisonRaw={totalComparison}
							percentage={percentageLabel(
								calcProPercentsBasedOnFilterAndDays(
									itemPercentage(outGoingDetailsTotal?.totalCommunityTransfer || 0, total, "number"),
									filter,
									projectionDays,
									filterTotal,
									averageCensus
								)
							)}
							percentageValue={itemPercentage(outGoingDetailsTotal?.totalCommunityTransfer || 0, averageCensus, "number")}
							percentageComparison={itemPercentage(outGoingDetailsTotalComparison?.totalCommunityTransfer || 0, averageCensus, "number")}
							filter={filter}
							filterComparison={filterComparison}
							projectionDays={projectionDays}
							isCompareColor={isCompareColor}
							isLayoutMode={isLayoutMode}
						/>
						<SubTotalCardItem
							title={"Deceased"}
							loading={loading}
							total={calcProPercentsBasedOnFilterAndDays(
								outGoingDetailsTotal?.totalDeceasedTransfer || 0,
								filter,
								projectionDays
							)}
							totalComparisonRaw={outGoingDetailsTotalComparison?.totalDeceasedTransfer || 0}
							totalRaw={outGoingDetailsTotal?.totalDeceasedTransfer || 0}
							totalOutgoingRaw={total}
							totalOutgoingComparisonRaw={totalComparison}
							percentage={percentageLabel(
								calcProPercentsBasedOnFilterAndDays(
									itemPercentage(outGoingDetailsTotal?.totalDeceasedTransfer || 0, total, "number"),
									filter,
									projectionDays,
									filterTotal,
									averageCensus
								)
							)}
							percentageValue={itemPercentage(outGoingDetailsTotal?.totalDeceasedTransfer || 0, averageCensus, "number")}
							percentageComparison={itemPercentage(outGoingDetailsTotalComparison?.totalDeceasedTransfer || 0, averageCensus, "number")}
							filter={filter}
							filterComparison={filterComparison}
							projectionDays={projectionDays}
							isCompareColor={isCompareColor}
							isLayoutMode={isLayoutMode}
						/>
					</Stack>
				</Grid>
			</Grid>
		</div>
	);
};

export default TotalOverallOutGoingCard;

const SubTotalCardItem = ({ 
	title, 
	total, 
	totalRaw,
	totalComparisonRaw,
	totalOutgoingRaw,
	totalOutgoingComparisonRaw,
	percentage, 
	percentageValue,
	percentageComparison,
	loading,
	filter,
	filterComparison,
	projectionDays,
	isCompareColor,
	isLayoutMode,
}) => {
	const [comparisonDiffColor, setComparisonDiffColor] = useState(null);
	const [comparingAgainstScaled, setComparingAgainstScaled] = useState(null);
	const [comparingAgainst, setComparingAgainst] = useState("");
	const [numberOfDays, setNumberOfDays] = useState(null);

	useEffect(() => {
		if (!isCompareColor || loading) {
			setComparisonDiffColor(null);
			setComparingAgainstScaled(null);
			setComparingAgainst("");
			setNumberOfDays(null);
			return;
		}

		const {
			percentageDiff,
			itemTotalComparisonScaled,
			numberOfDays: numberOfDaysTemp,
		} = calculateDiffBetweenPercentages(
			percentageValue || 0,
			percentageComparison || 0,
			false,
			filter,
			filterComparison,
			totalComparisonRaw || 0,
			projectionDays
		);

		setNumberOfDays(numberOfDaysTemp);
		setComparingAgainstScaled(itemTotalComparisonScaled);
		setComparingAgainst(totalComparisonRaw || 0);

		const percentageChange = pickComparisonColor(percentageDiff, false);
		setComparisonDiffColor(percentageChange);
	}, [
		percentageValue,
		percentageComparison,
		filter,
		filterComparison,
		totalComparisonRaw,
		projectionDays,
		isCompareColor,
		loading,
	]);

	return (
		<Stack item sx={{ width: "90%", borderRadius: "5px" }} className={loading ? "skeleton" : undefined}>
			
			<div className={classNames(styles.projectionContainer, styles.withSubTotalCard, loading && styles.skeleton)}>
				<div className={`${styles.projectionTitle}`}>
					{loading ? (
						<span className="skeleton-text" style={{ visibility: "hidden" }}>
							{title}
						</span>
					) : (
						title
					)}
				</div>
				<div className={`${styles.projectionSubTitle}`} style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row", gap: "4px" }}>
					{loading ? (
						<span className="skeleton-text" style={{ visibility: "hidden" }}>
							{total} {percentage}
						</span>
					) : (
						<>
							<span style={{ order: 1 }}>{`${total} ${percentage}`}</span>
							{isCompareColor && !loading && comparisonDiffColor && (
								<span style={{ order: 2 }}>
									<ColorBox
										color={comparisonDiffColor}
										comparingAgainst={comparingAgainst}
										comparingAgainstScaled={comparingAgainstScaled}
										numberOfDays={numberOfDays}
										loading={loading}
										loadingComparison={false}
										isLayoutMode={isLayoutMode}
										sx={{ height: "18px", width: "9px" }}
										isTotalOverallCard={true}
									/>
								</span>
							)}
						</>
					)}
				</div>
			</div>
		</Stack>
	);
};
